import { ResourceType } from "./Publication";

const resourceTypes: ResourceType[] = [
    { 
        name: "Tablas", 
        abreviation: "TABLE",
        icon: "icon-vpro-table",
        class: "icon-vpro-table"        
    },
    { 
        name: "Infografias", 
        abreviation: "INF",
        icon: "icon-vpro-sec-infographics",
        class: "icon-vpro-sec-infographics"        
    },
    { 
        name: "Procesos", 
        abreviation: "PRC",
        icon: "icon-vpro-sec-visitas",
        class: "icon-vpro-sec-visitas"        
    },    
    { 
        name: "Videos", 
        abreviation: "VIDEO",
        icon: "icon-vpro-sec-videos",
        class: "icon-vpro-sec-videos"        
    },    
    { 
        name: "Perfiles", 
        abreviation: "PERFIL",
        icon: "icon-vpro-sec-profiles",
        class: "icon-vpro-sec-profiles"        
    },  
    { 
        name: "Laboratorios", 
        abreviation: "LAB",
        icon: "icon-vpro-sec-labs_1",
        class: "icon-vpro-sec-labs_1"        
    },
    {
        name: "Imágenes", 
        abreviation: "OVA",
        icon: "icon-vpro-media-image-alt",
        class: "icon-vpro-media-image-alt"
    },
    {
        name: "Galerías", 
        abreviation: "GAL",
        icon: "icon-vpro-media-image",
        class: "icon-vpro-media-image"
    },
    {
        name: "3D", 
        abreviation: "SKF",
        icon: "icon-vpro-sec-showoom",
        class: "icon-vpro-sec-showoom"
    }
]

export default resourceTypes